<template>
  <div class="component quantity-picker">
    <span class="step minus" v-bind:class="{ active: minusActive }" v-on:click="minus"></span>
    <input type="number" v-model.number="inputValue" @input="onInput" :readonly="!active || readonly" />
    <span class="step plus" v-bind:class="{ active: plusActive }" v-on:click="plus"></span>
  </div>
</template>

<script>
export default {
  props: {
    min: {
      type: Number,
      default: 0
    },
    max: Number,
    value: {
      type: Number,
      default: 0
    },
    step: {
      type: Number,
      default: 1
    },
    readonly: {
      type: Boolean,
      default: true
    },
    active: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },

    minusActive() {
      return this.active && (this.min === undefined || this.inputValue > this.min)
    },

    plusActive() {
      return this.active && (this.max === undefined || this.inputValue < this.max);
    },
  },

  created(){
    this.inputValue = this.inputValue;
  },

  methods: {
    minus() {
      this.adjustValue(-this.step);
    },

    plus() {
      this.adjustValue(this.step);
    },

    adjustValue(a) {
      this.inputValue = this.clamp(this.inputValue + a);
    },

    clamp(v) {
      v = parseInt(v);
      if (this.min !== undefined) {
        v = Math.max(this.min, v);
      }
      if (this.max !== undefined) {
        v = Math.min(this.max, v);
      }
      return v;
    },

    onInput(e) {
      this.inputValue = this.clamp(e.target.value);
    }

  }
}
</script>

<style lang="scss">

.quantity-picker {
  @include clearfix;
  width: 100%;

  .step, input {
    display: block;
    float: left;
    height: 25px;
    line-height: 25px;
    padding: 0;
  }

  .step {
    background-color: #bbb;
    color: #fff;
    border-radius: 4px;
    width: 25px;
    height: 25px;
    display: flex !important;
    justify-content: center;
    align-items: center;
    user-select: none;
    pointer-events: none;

    &.active {
      background-color: $colorCTA;
      cursor: pointer;
      pointer-events: all;
    }
  }

  .minus {
    @include font-awesome($fa-var-minus, light);
  }

  .plus {
    @include font-awesome($fa-var-plus, light);
  }

  input {
    width: calc(100% - 50px);
    border: none;
    text-align: center;

    &:focus {
      box-shadow: none;
    }
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
      /* display: none; <- Crashes Chrome on hover */
      -webkit-appearance: none;
      margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }

  input[type=number] {
      -moz-appearance:textfield; /* Firefox */
  }  
}
</style>